module.exports = __webpack_public_path__ + "img/dollar.fed8b5c9.png";